import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { languageSettings } from '../lenguajeDatatable';
import { ApiService } from '../services/api.service';
import { ToastService } from '../services/toast.service';
import { LoadingService } from '../services/loading.service';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-fixedheader';

@Component({
  selector: 'app-persona-comparacion',
  templateUrl: './persona-comparacion.component.html',
  styleUrl: './persona-comparacion.component.css',
})
export class PersonaComparacionComponent implements AfterViewInit, OnDestroy {
  constructor(
    private apiService: ApiService,
    private toastService: ToastService,
    private loadingService: LoadingService
  ) {}

  dataTable: any;
  listaPersonasIncongruentes: any[] = [];
  persona: any = {};
  personaIncongruente: any = {};
  seleccion: any = {};
  mostrarTabla: boolean = false;
  nuevaPersona: any = {};

  campos = [
    { nombre: 'documento', nombreTabla: 'Documento' },
    { nombre: 'nombre', nombreTabla: 'Nombre' },
    { nombre: 'apellido', nombreTabla: 'Apellido' },
    { nombre: 'sitRevistaAfip', nombreTabla: 'Situación Revista AFIP' },
    { nombre: 'revista', nombreTabla: 'Revista' },
    { nombre: 'tipoBeneficiario', nombreTabla: 'Tipo Beneficiario' },
    { nombre: 'idAfiliado', nombreTabla: 'ID Afiliado' },
    { nombre: 'fechaNacimiento', nombreTabla: 'Fecha Nacimiento' },
    { nombre: 'telefono', nombreTabla: 'Teléfono' },
    { nombre: 'cuilTitular', nombreTabla: 'CUIL Titular' },
    { nombre: 'numeroAfiliado', nombreTabla: 'Número Afiliado' },
    { nombre: 'parentesco', nombreTabla: 'Parentesco' },
    { nombre: 'nacionalidad', nombreTabla: 'Nacionalidad' },
    { nombre: 'estadoCivil', nombreTabla: 'Estado Civil' },
    { nombre: 'sexo', nombreTabla: 'Sexo' },
    { nombre: 'obraSocial', nombreTabla: 'Obra Social' },
    { nombre: 'idLocalidad', nombreTabla: 'ID Localidad' },
    { nombre: 'domicilio', nombreTabla: 'Domicilio' },
  ];

  ngAfterViewInit(): void {
    this.inicializarDataTable();
    this.cargarPersonasIncongruentes();
  }

  ngOnDestroy(): void {
    if (this.dataTable) {
      this.dataTable.destroy(true);
    }
  }

  private inicializarDataTable(): void {
    this.dataTable = $('#personaComparacionTable').DataTable({
      language: languageSettings,
      pageLength: 20,
      responsive: true,
      dom: 'tr',
      ordering: false,
      fixedHeader: {
        header: true,
        headerOffset: $('.header').height(), // Ajusta el desplazamiento según la altura de la barra superior
      },
    });
  }

  private cargarPersonasIncongruentes(): void {
    this.apiService.obtenerPersonasIncongruentes().subscribe((data: any[]) => {
      this.listaPersonasIncongruentes = data;
    });
  }

  onSelectPersonaIncongruente(event: any): void {
    this.loadingService.setLoading(true);
    const cuil = event.target.value;
    if (cuil) {
      const numeroDeCuil = Number(cuil);
      this.personaIncongruente =
        this.listaPersonasIncongruentes.find(
          (personaIncongruente) => personaIncongruente.cuil === numeroDeCuil
        ) || {};
      this.apiService.obtenerPersona(cuil).subscribe((data) => {
        this.loadingService.setLoading(false);
        this.persona = data;
      });
      this.mostrarTabla = true;
    } else {
      this.loadingService.setLoading(false);
      this.mostrarTabla = false;
      this.personaIncongruente = {};
      this.persona = {};
    }
  }

  onSelect(campo: string, prefijo: string, valor: any): void {
    const currentKey = `${prefijo}_${campo}`;
    const otherKey =
      prefijo === 'persona'
        ? `personaIncongruente_${campo}`
        : `persona_${campo}`;

    if (this.seleccion[currentKey] === valor) {
      delete this.seleccion[currentKey];
    } else {
      this.seleccion[currentKey] = valor;
      delete this.seleccion[otherKey];
    }
  }

  getCampoDescripcion(persona: any, campo: string): string {
    const valor = persona[campo];
    return valor && typeof valor === 'object' && valor.descripcion
      ? valor.descripcion
      : valor;
  }

  seleccionarTodo(tipo: string): void {
    this.campos.forEach((campo) => {
      const prefijo = tipo === 'persona' ? 'persona' : 'personaIncongruente';
      const valor =
        tipo === 'persona'
          ? this.persona[campo.nombre]
          : this.personaIncongruente[campo.nombre];
      const otherKey =
        prefijo === 'persona'
          ? `personaIncongruente_${campo.nombre}`
          : `persona_${campo.nombre}`;

      this.seleccion[`${prefijo}_${campo.nombre}`] = valor;
      delete this.seleccion[otherKey];
    });
  }

  deseleccionarTodo(): void {
    this.seleccion = {};
  }

  crearNuevaPersonaDto(): void {
    const camposFaltantes = this.campos.filter((campo) => {
      const personaKey = `persona_${campo.nombre}`;
      const personaIncongruenteKey = `personaIncongruente_${campo.nombre}`;
      return (
        !(personaKey in this.seleccion) &&
        !(personaIncongruenteKey in this.seleccion)
      );
    });

    if (camposFaltantes.length > 0) {
      this.toastService.mostrarNotificacion(
        'Debe seleccionar al menos un valor para cada campo',
        'warning'
      );
      return;
    }

    this.loadingService.setLoading(true);
    this.campos.forEach((campo) => {
      const personaKey = `persona_${campo.nombre}`;
      const personaIncongruenteKey = `personaIncongruente_${campo.nombre}`;

      if (this.seleccion[personaKey] !== undefined) {
        this.nuevaPersona[campo.nombre] = this.seleccion[personaKey];
      } else if (this.seleccion[personaIncongruenteKey] !== undefined) {
        this.nuevaPersona[campo.nombre] =
          this.seleccion[personaIncongruenteKey];
      }
    });

    const personaDTO = {
      cuil: this.persona['cuil'],
      documento: this.nuevaPersona.documento,
      nombre: this.nuevaPersona.nombre,
      apellido: this.nuevaPersona.apellido,
      telefono: this.nuevaPersona.telefono,
      fechaNacimiento: this.nuevaPersona.fechaNacimiento,
      fechaEstado: this.nuevaPersona.fechaEstado,
      cuilTitular: this.nuevaPersona.cuilTitular,
      domicilio: this.nuevaPersona.domicilio,
      idEstadoCivil: this.nuevaPersona.estadoCivil?.id,
      idParentesco: this.nuevaPersona.parentesco?.id,
      idSexo: this.nuevaPersona.sexo?.id,
      idTipoBeneficiario: this.nuevaPersona.tipoBeneficiario?.id,
      idObraSocial: this.nuevaPersona.obraSocial?.id,
      idNacionalidad: this.nuevaPersona.nacionalidad?.id,
      idRevista: this.nuevaPersona.revista?.id,
      numeroAfiliado: this.nuevaPersona.numeroAfiliado,
    };

    this.apiService
      .resolverPersonaIncongruente(personaDTO)
      .subscribe((response) => {
        if (response) {
          this.loadingService.setLoading(false);
          this.toastService.mostrarNotificacion(
            'Persona resuelta correctamente',
            'success'
          );
          this.mostrarTabla = false;
          this.personaIncongruente = {};
          this.persona = {};
          this.seleccion = {};
          this.cargarPersonasIncongruentes();
        } else {
          this.loadingService.setLoading(false);
          this.toastService.mostrarNotificacion(
            'Error al resolver la persona',
            'error'
          );
        }
      });
  }
}
